import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type DefaultState = {
  commonList: any
  page: number,
  prevPage: number,
  filterKey: string,
}

const initialState: DefaultState = {
  commonList: [],
  page: 1,
  prevPage: 0,
  filterKey: '',
}

export const FeedSlice = createSlice({
  name: "feedList",
  initialState: initialState,
  reducers: {
    setInitialFeedList: (state, action: PayloadAction<any>) => {
      state.commonList = action.payload
    },
    setDataToFeedList: (state, action: PayloadAction<any>) => {
      const mergedList = [...state.commonList, ...action.payload];
      const uniqueItems = Array.from(new Map(mergedList.map(item => [item.id, item])).values());

      state.commonList = uniqueItems;
    },
    setPrevFeedPage: (state, action: PayloadAction<number>) => {
      state.prevPage = action.payload
    },
    setFeedPage: (state, action: PayloadAction<number>) => {
      state.page = state.page + action.payload
    },
    filterBrokenMovie: (state, action: PayloadAction<number>) => {
      state.commonList = state.commonList.filter((item: any) => item.id !== action.payload)
    },
    setCountFeed: (state, action: PayloadAction<{id: number, key: string, type: string}>) => {
      const dat: any = [...state.commonList];
      const itemIndex = dat.findIndex((item: any) => item.id === action.payload.id);
      if (itemIndex !== -1) {
        dat[itemIndex] = {
          ...dat[itemIndex],
          [action.payload.key]: action.payload.type === 'increment'
            ? dat[itemIndex][action.payload.key] + 1 : dat[itemIndex][action.payload.key] - 1
        };
      }

      state.commonList = dat;
    },
    cleanUpFeedPage: (state) => {
      state.page = 1;
      state.prevPage = 0;
      state.commonList = []
    },
    setFeedFilterKey: (state, action: PayloadAction<string>) => {
      state.filterKey = action.payload;
    },
  },
})

export default FeedSlice.reducer
export const {
  setInitialFeedList,
  setDataToFeedList,
  setCountFeed,
  setFeedPage,
  filterBrokenMovie,
  cleanUpFeedPage,
  setPrevFeedPage,
  setFeedFilterKey,
} = FeedSlice.actions
